// @flow

import moment from 'moment'

import {
  FETCH_LOCKED_LEVELS_REQUEST,
  FETCH_LOCKED_LEVELS_SUCCESS,
  FETCH_LOCKED_LEVELS_FAILURE,
  FETCH_ENGAGEMENT_USERS_REQUEST,
  FETCH_ENGAGEMENT_USERS_SUCCESS,
  FETCH_ENGAGEMENT_USERS_FAILURE,
  FETCH_USERS_DAILY_EFFORTS_SUCCESS,
  SET_MY_STUDENTS_SORT,
  SET_MY_STUDENTS_SEARCH_TEXT,
  SET_MY_STUDENTS_SELECTED_TAB,
  SET_MY_STUDENTS_COURSE_FILTER,
  SET_MY_STUDENTS_SKILLS_LEVEL_FILTER,
  SET_MY_STUDENTS_DATE_FILTER,
  REMOVE_LOCKED_LEVEL,
  UPDATE_USER_DAILY_EFFORT_REQUEST,
  UPDATE_USER_DAILY_EFFORT_SUCCESS,
  DELETE_USER_DAILY_EFFORT_SUCCESS,
  ADD_EMPTY_ROW_TO_USER_DAILY_EFFORTS,
  EXPAND_LEVEL_COLUMN,
  COLLAPSE_LEVEL_COLUMN,
  SET_DISPLAY_LEVEL_VIEW,
  SET_MY_STUDENTS_TRENDS_VIEW,
  MY_STUDENTS_FETCH_OVERALL_QUESTS_PROGRESS,
  MY_STUDENTS_DELETE_TARGET_DATE_SUCCESS,
  MY_STUDENTS_UPDATE_TARGET_DATE_ALL,
  MY_STUDENTS_CREATE_TARGET_DATE_SUCCESS,
  MY_STUDENTS_UPDATE_TARGET_DATE_SUCCESS,
  MY_STUDENTS_UPDATE_TARGET_DATE_ALL_SUCCESS
} from '../actions/mystudents'
import { myStudentsDisplayLevelView } from '../constants'

const initialState: {
  lockedLevels: Array<Object>,
  engagementUsers: Array<Object>,
  isFetchingEngagementUsers: boolean,
  engagementUpdatingId: number,
  searchText: string,
  selectedTab: string,
  sortField: string,
  sortDirection: string,
  courseSectionId: number,
  skillsLevelId: number,
  dateFilter: string,
  displayLevelView: string,
  trendsView: string,
  overallQuestsProgress: Array<Object>
} = {
  lockedLevels: [],
  engagementUsers: [],
  isFetchingEngagementUsers: false,
  engagementUpdatingId: -1,
  searchText: '',
  selectedTab: 'journeyoverview',
  sortField: 'journeyprogress',
  sortDirection: 'asc',
  courseSectionId: -1,
  skillsLevelId: -1,
  dateFilter: moment().format('YYYY-MM-DD'),
  expandedLevels: [],
  displayLevelView: myStudentsDisplayLevelView.overview,
  overallQuestsProgress: [],
  trendsView: 'engagement'
}

export function mystudents(state = initialState, action) {
  switch (action.type) {
    case ADD_EMPTY_ROW_TO_USER_DAILY_EFFORTS: {
      const engagementUsers = state.engagementUsers.splice(0)
      const user = engagementUsers.find(eu => eu.id === action.studentId)

      if (user) {
        user.efforts.push(action.record)
      }

      return Object.assign({}, state, {
        engagementUsers: engagementUsers,
        engagementUpdatingId: 'ADD'
      })
    }

    case FETCH_ENGAGEMENT_USERS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingEngagementUsers: true,
        engagementUsers: []
      })
    }

    case FETCH_ENGAGEMENT_USERS_FAILURE: {
      return Object.assign({}, state, {
        isFetchingEngagementUsers: false,
        engagementUsers: []
      })
    }

    case FETCH_ENGAGEMENT_USERS_SUCCESS: {
      // map engagementEfforts onto users
      action.engagementUsers.forEach(user => {
        user.efforts = action.engagementEfforts.filter(
          effort => effort.user_id === user.id
        )
      })

      return Object.assign({}, state, {
        isFetchingEngagementUsers: false,
        engagementUsers: action.engagementUsers
      })
    }

    case FETCH_USERS_DAILY_EFFORTS_SUCCESS: {
      const usersInState = state.engagementUsers.splice(0)

      // map engagementEfforts onto users
      usersInState.forEach(user => {
        user.efforts = action.engagementEfforts.filter(
          effort => effort.user_id === user.id
        )
      })

      return Object.assign({}, state, {
        engagementUsers: usersInState
      })
    }

    case UPDATE_USER_DAILY_EFFORT_REQUEST: {
      return Object.assign({}, state, {
        engagementUpdatingId: -1 // ensure last edited record isn't updated accidentally
      })
    }

    case UPDATE_USER_DAILY_EFFORT_SUCCESS: {
      if (action.updateUI) {
        const users = state.engagementUsers.splice(0) // copy users
        const user = users.find(
          user => user.id === action.userDailyEfforts.user_id
        ) // find updated user
        const index = user.efforts.findIndex(
          e => e.id === action.userDailyEfforts.id
        ) // find index of effort row that was saved
        user.efforts.splice(index, 1, action.userDailyEfforts) // replace the old record with the updated one

        return Object.assign({}, state, {
          engagementUsers: users,
          engagementUpdatingId: action.userDailyEfforts.id
        })
      } else {
        // noop
        return Object.assign({}, state, {
          engagementUsers: state.engagementUsers
        })
      }
    }

    case DELETE_USER_DAILY_EFFORT_SUCCESS: {
      const users = state.engagementUsers.splice(0) // copy users
      const user = users.find(user => user.id === action.studentId) // find user

      // find index of effort row that was deleted
      const index = !isNaN(action.effortId)
        ? user.efforts.findIndex(e => e.id === action.effortId)
        : user.efforts.findIndex(e => e.id === undefined)

      user.efforts.splice(index, 1) // remove the record

      return Object.assign({}, state, {
        engagementUsers: users,
        engagementUpdatingId: 'DELETE'
      })
    }

    case FETCH_LOCKED_LEVELS_REQUEST:
      return Object.assign({}, state, {
        lockedLevels: []
      })

    case FETCH_LOCKED_LEVELS_FAILURE:
      return Object.assign({}, state, {
        lockedLevels: []
      })

    case FETCH_LOCKED_LEVELS_SUCCESS:
      return Object.assign({}, state, {
        lockedLevels: action.lockedLevels
      })

    case REMOVE_LOCKED_LEVEL:
      const copiedLockedLevels = state.lockedLevels.slice()
      const indexToRemove = copiedLockedLevels.findIndex(
        level => level.id === action.levelId
      )
      copiedLockedLevels.splice(indexToRemove, 1)

      return Object.assign({}, state, {
        lockedLevels: copiedLockedLevels
      })

    case SET_MY_STUDENTS_SEARCH_TEXT:
      return Object.assign({}, state, {
        searchText: action.searchText
      })

    case SET_MY_STUDENTS_SELECTED_TAB:
      return Object.assign({}, state, {
        selectedTab: action.tab
      })

    case SET_MY_STUDENTS_SORT:
      return Object.assign({}, state, {
        sortField: action.field,
        sortDirection: action.direction
      })

    case SET_MY_STUDENTS_COURSE_FILTER:
      localStorage.setItem('courseSectionId', action.courseSectionId)
      return Object.assign({}, state, {
        courseSectionId: action.courseSectionId,
        expandedLevels: []
      })

    case SET_MY_STUDENTS_SKILLS_LEVEL_FILTER:
      return Object.assign({}, state, {
        skillsLevelId: action.levelId
      })

    case SET_MY_STUDENTS_DATE_FILTER:
      return Object.assign({}, state, {
        dateFilter: action.dateFilter.format('YYYY-MM-DD')
      })

    case EXPAND_LEVEL_COLUMN: {
      return Object.assign({}, state, {
        expandedLevels: state.expandedLevels.concat(action.payload.id)
      })
    }

    case COLLAPSE_LEVEL_COLUMN: {
      return Object.assign({}, state, {
        expandedLevels: state.expandedLevels.filter(
          el => el !== action.payload.id
        )
      })
    }
    case SET_DISPLAY_LEVEL_VIEW:
      return Object.assign({}, state, {
        displayLevelView: action.payload.displayLevelView
      })
    case SET_MY_STUDENTS_TRENDS_VIEW:
      return Object.assign({}, state, {
        trendsView: action.payload.trendsView
      })
    case MY_STUDENTS_FETCH_OVERALL_QUESTS_PROGRESS:
      return Object.assign({}, state, {
        overallQuestsProgress: action.payload
      })
    case MY_STUDENTS_UPDATE_TARGET_DATE_ALL:
      return Object.assign({}, state, {
        overallQuestsProgress: state.overallQuestsProgress.map(oqp => {
          let isExist = false
          oqp.quest_target_dates = oqp.quest_target_dates.map(qtd => {
            if (qtd.quest_id === action.payload.questId) {
              isExist = true
              return {
                id: action.payload.id,
                level_id: action.payload.levelId,
                quest_id: action.payload.questId,
                target_on: action.payload.targetOn,
                isFetching: oqp.user_id !== action.payload.studentId
              }
            }
            return qtd
          })
          if (!isExist) {
            oqp.quest_target_dates = [
              ...oqp.quest_target_dates,
              {
                id: action.payload.id,
                level_id: action.payload.levelId,
                quest_id: action.payload.questId,
                target_on: action.payload.targetOn,
                isFetching: oqp.user_id !== action.payload.studentId
              }
            ]
          }
          return oqp
        })
      })
    case MY_STUDENTS_UPDATE_TARGET_DATE_ALL_SUCCESS:
      return Object.assign({}, state, {
        overallQuestsProgress: state.overallQuestsProgress.map(oqp => {
          const targetDate = action.payload.target_dates_updated.find(
            tdu => tdu.user_id === oqp.user_id
          )
          if (targetDate) {
            let isExist = false
            oqp.quest_target_dates = oqp.quest_target_dates.map(qtd => {
              if (
                qtd.quest_id === action.payload.quest_id &&
                qtd.level_id === action.payload.level_id
              ) {
                isExist = true
                return {
                  ...targetDate,
                  ...{
                    quest_id: action.payload.quest_id,
                    level_id: action.payload.level_id
                  }
                }
              }
              return qtd
            })

            if (!isExist) {
              oqp.quest_target_dates = [
                ...oqp.quest_target_dates,
                ...[
                  {
                    ...targetDate,
                    ...{
                      quest_id: action.payload.quest_id,
                      level_id: action.payload.level_id
                    }
                  }
                ]
              ]
            }
          }
          return oqp
        })
      })
    case MY_STUDENTS_DELETE_TARGET_DATE_SUCCESS:
      return Object.assign({}, state, {
        overallQuestsProgress: state.overallQuestsProgress.map(oqp => {
          if (oqp.user_id === action.payload.studentId) {
            oqp.quest_target_dates = oqp.quest_target_dates.filter(
              qtd => qtd.id !== action.payload.id
            )
          }
          return oqp
        })
      })
    case MY_STUDENTS_UPDATE_TARGET_DATE_SUCCESS:
      return Object.assign({}, state, {
        overallQuestsProgress: state.overallQuestsProgress.map(oqp => {
          if (oqp.user_id === action.payload.studentId) {
            oqp.quest_target_dates = oqp.quest_target_dates.map(qtd => {
              if (qtd.quest_id === action.payload.questId) {
                return {
                  id: action.payload.id,
                  level_id: action.payload.levelId,
                  quest_id: action.payload.questId,
                  courseSectionId: action.payload.courseSectionId,
                  target_on: action.payload.targetOn
                }
              }
              return qtd
            })
          }
          return oqp
        })
      })
    case MY_STUDENTS_CREATE_TARGET_DATE_SUCCESS:
      return Object.assign({}, state, {
        overallQuestsProgress: state.overallQuestsProgress.map(oqp => {
          if (oqp.user_id === action.payload.studentId) {
            oqp.quest_target_dates = oqp.quest_target_dates = [
              ...oqp.quest_target_dates,
              {
                id: action.payload.id,
                level_id: action.payload.levelId,
                quest_id: action.payload.questId,
                target_on: action.payload.targetOn,
                courseSectionId: action.payload.courseSectionId
              }
            ]
          }
          return oqp
        })
      })
    default:
      return state
  }
}
